/* eslint-disable max-len */
import { Icon as MuiIcon, TableBody, TableHead, TableRow } from "@mui/material";
import Icon from "../../components/Icon";
import { useMemo, useState, useEffect, useContext } from "react";
import { useScreenClass } from "react-grid-system";
import { Link, useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import { CustomBlock, StyledImg } from "../../components/CompetenciesList";
import FlexBox, { FlexGrow } from "../../components/FlexBox";
import SearchCompetencies from "../../components/SearchCompetencies";
import TabGroup, { TabItem } from "../../components/TabGroup";
import {
  NullStateText,
  StyledText,
  TextSize,
  TextStatus,
} from "../../components/Text";
import theme from "../../styles/theme";
import { CompetencyType, EmptyCompetency } from "../../types/Competency";
import TableComponent, {
  StyledBodyCell,
  StyledHeaderCell,
  StyledTableRow,
  StyledTableRowNoHover,
} from "../../components/Table";
import ALink from "../../components/ALink";
import { useLocalStorage } from "../../hooks/useLocalStorage";
import axios from "axios";
import { VersionContext } from "../../context/VersionContext";
import LoadingSpinner from "../../components/LoadingSpinner";

const customComps = [
  {
    id: "26a90c73-0639-4f65-ba65-de3321a78c1b",
    title: "Programming Essentials",
    description: "",
    competency_code: "AIC-099",
    required: false,
    specified: true,
    available: false,
    semester_name: "",
    date_available: "",
    instructor: "",
    credits: 4,
    min_optional: 0,
    prerequisites: null,
    semester_detail: {
      semester_name: "",
      instructor: "",
      start_date: "",
      end_date: "",
      assessment_only: false,
      course_url: "",
    },
    skills: [
      {
        id: "60acf3d0-f3f6-41dd-977c-c26d42690e14",
        title: "Writing a simple, single module program",
        description: "",
        skill_code: "AIC-099:00010",
        required: true,
        assessment: {
          id: "e95659ff-9ca0-4b7f-9610-20ad50aa5aa0",
          title: "Assessment: Writing a simple, single module program",
          description:
            "Given a simple problem, write, test and explain a program that solves this problem",
          external_url: "",
        },
      },
    ],
    graphics: {
      icon: "webhook",
      iconbg:
        "linear-gradient(90deg, rgb(227, 79, 7) -10%, rgb(227, 7, 7) 50%, rgb(166, 54, 55) 110%)",
      bordercolor:
        "linear-gradient(90deg, rgb(227, 79, 7) -10%, rgb(227, 7, 7) 50%, rgb(166, 54, 55) 110%)",
      iconshadow: "0px 0px 6px rgb(239 7 7)",
      imgurl: "./AI/ProgrammingEssentials.png",
    },
  },
  {
    id: "7dbcf514-b2ae-430b-b4c7-16e17d313404",
    title: "Algorithmic Thinking \u0026 Problem Solving",
    description: "",
    competency_code: "AIC-101",
    required: true,
    specified: true,
    available: true,
    semester_name: "Fall 2022",
    date_available: "2022-08-29",
    instructor: "Sally Goldin",
    credits: 2,
    min_optional: 0,
    prerequisites: null,
    semester_detail: {
      semester_name: "",
      instructor: "",
      start_date: "",
      end_date: "",
      assessment_only: false,
      course_url: "",
    },
    skills: [
      {
        id: "407bd7f2-824d-48b4-86e8-14cd828a15cd",
        title: "Turning verbal specifications into algorithms",
        description: "",
        skill_code: "AIC-101:00010",
        required: true,
        assessment: {
          id: "7664f0e7-39a7-496a-a4c0-c804bff789cb",
          title: "Assessment: Turning verbal specifications into algorithms",
          description:
            "Given a written specification for what a non-trivial program should do, create a detailed set of flowcharts or pseudocode that correctly expresses a solution",
          external_url: "",
        },
      },
    ],
    graphics: {
      icon: "webhook",
      iconbg:
        "linear-gradient(90deg, rgb(227, 79, 7) -10%, rgb(227, 7, 7) 50%, rgb(166, 54, 55) 110%)",
      bordercolor:
        "linear-gradient(90deg, rgb(227, 79, 7) -10%, rgb(227, 7, 7) 50%, rgb(166, 54, 55) 110%)",
      iconshadow: "0px 0px 6px rgb(239 7 7)",
      imgurl: "./AI/AlgorithmicThinkingandProblemSolving.png",
    },
  },
];
const Header = styled.h4`
  font-style: normal;
  font-weight: 700;
  letter-spacing: 0px;
  text-align: left;
  color: ${theme.color.darkBlueGray900};
  margin-bottom: 0px;
`;
const CustomFlex = styled(FlexBox)`
  padding: 20px 0;
  align-items: center;
  border-bottom: 3px solid rgb(243, 244, 246);
`;
const CustomFlexPlain = styled(FlexBox)`
  padding: 15px 10px;
  align-items: flex-start;
`;
const CustomGrowPlain = styled(FlexGrow)`
  min-width: 150px;
  flex-grow: 0;
`;
const CustomGrow = styled(FlexGrow)`
  align-self: stretch;
  flex-grow: 0;
  border-right: 3px solid rgb(243, 244, 246);
`;
const Label = styled.h5`
  text-transform: uppercase;
  color: ${theme.color.darkBlueGray900};
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: left;
`;
const LabelData = styled(StyledText)`
  color: ${theme.color.lightBlueGray500};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0.20000000298023224px;
  text-align: left;
  vertical-align: text-top;
`;
const Ul = styled.ul`
  color: ${theme.color.lightBlueGray500};
  padding-inline-start: 16px;
  margin-block-start: 0;
  margin-block-end: 0;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: left;
`;
const LI = styled.li`
  color: ${theme.color.lightBlueGray500};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0.20000000298023224px;
  text-align: left;
  vertical-align: text-top;
`;
const LiGradient = styled.li`
  font-style: normal;
  font-weight: 400;
  letter-spacing: 0.20000000298023224px;
  text-align: left;
  vertical-align: text-top;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent;
  margin-bottom: 5px;
  text-decoration: underline;
`;
interface SkillColumn {
  id:
    | "skill_code"
    | "title"
    | "ordinal"
    | "knowledge_topic"
    | "cognitive_level"
    | "assessment_description";
  label: string;
  minWidth?: number;
  align?: "right";
  format?: (value: number) => string;
}
interface CourseColumn {
  id: "title" | "number" | "pillar" | "competencies";
  label: string;
  minWidth?: number;
  align?: "right";
  format?: (value: number) => string;
}
const courseColumns: readonly CourseColumn[] = [
  { id: "title", label: "Course Title", minWidth: 200 },
  {
    id: "number",
    label: "Course Number",
    minWidth: 150,
  },
  { id: "pillar", label: "Pillar", minWidth: 80 },

  {
    id: "competencies",
    label: "Competencies",
    minWidth: 250,
  },
];
const skillColumns: readonly SkillColumn[] = [
  { id: "title", label: "Skill Title", minWidth: 200 },
  {
    id: "ordinal",
    label: "Skill Ordinal",
    minWidth: 150,
  },
  { id: "skill_code", label: "Skill Code", minWidth: 80 },

  {
    id: "knowledge_topic",
    label: "Knowledge Topic",
    minWidth: 100,
  },
  {
    id: "cognitive_level",
    label: "Cognitive Level",
    minWidth: 100,
  },
  {
    id: "assessment_description",
    label: "Assessment Description",
    minWidth: 200,
  },
];
function ViewCompetencyDetail() {
  const navigate = useNavigate();
  const routeParams = useParams() as Record<string, string | undefined>;
  let competencyCode =
    routeParams.competencyCode || routeParams.competency_code || routeParams.id;
  let identity_university =
    routeParams.identity_university || routeParams.university;
  let identity_version = routeParams.identity_version || routeParams.version;

  if (!competencyCode || !identity_university || !identity_version) {
    const segs = window.location.pathname.split("/").filter(Boolean);

    if (segs.length >= 3) {
      const last3 = segs.slice(-3);
      competencyCode = competencyCode || last3[0];
      identity_university = identity_university || last3[1];
      identity_version = identity_version || last3[2];
    }
  }
  // optional: trim values
  competencyCode = competencyCode?.trim();
  identity_university = identity_university?.trim();
  identity_version = identity_version?.trim();

  const [tab, setTab] = useState(0);
  const screenClass = useScreenClass();
  const isMobile = useMemo(
    () => ["xs", "sm"].includes(screenClass),
    [screenClass]
  );
  const [navigatedCompetencies, setNavigatedCompetencies] = useLocalStorage(
    "competencies",
    []
  );
  const [snackbarOpen, setSnackbarOpen] = useState<boolean>(false);
  const [competency, setCompetency] = useState<CompetencyType>(EmptyCompetency);
  const [searchResult, setSearchResult] = useState<string>("");
  const [competencies, setCompetencies] = useState<Array<any>>([]);
  const [loading, setLoading] = useState<Boolean>(false);
  const { version } = useContext(VersionContext);
  const universityCode = localStorage.getItem("university");

  console.log("competnecy", competency);
  const searchCompetency = (keyword: string) => {
    const found = filterArrayElementByCode(keyword);
    if (found && found.id) {
      setSearchResult(found.id);
    } else {
      setSnackbarOpen(true);
      setSearchResult("");
    }
  };
  useEffect(() => {
    if (version.version_number === 0 && !identity_version) {
      navigate("/curriculum/version");
    }
    fetchCompetencies();
  }, []);
  useEffect(() => {
    setTab(0);
    if (competencyCode) fetchCompetency(competencyCode);
  }, [competencyCode]);

  // const fetchCompetency = (id: string) => {
  //   setLoading(true);
  //   axios
  //     .get(
  //       `/competency/detail?competency_code=${id}&university_code=${
  //         identity_university || universityCode
  //       }&curriculum_version=${identity_version || version.version_number}`
  //     )
  //     .then((res) => {
  //       if (res.data.competency) {
  //         setCompetency(res.data.competency);
  //         const foundDuplicate = navigatedCompetencies.findIndex(
  //           (el: CompetencyType) => el.competency_code === competencyCode
  //         );
  //         if (foundDuplicate !== -1) {
  //           const newArray = navigatedCompetencies.splice(
  //             0,
  //             foundDuplicate + 1
  //           );
  //           setNavigatedCompetencies(newArray);
  //         } else {
  //           if (res.data.competency) {
  //             setNavigatedCompetencies([
  //               ...navigatedCompetencies,
  //               res.data.competency,
  //             ]);
  //           }
  //         }
  //       }
  //     })
  //     .catch(() => {
  //       setCompetencies([]);
  //     })
  //     .finally(() => setLoading(false));
  // };

  const fetchCompetency = (id: string) => {
    setLoading(true);
    axios
      .get(
        `/competency/detail?competency_code=${id}&university_code=${
          identity_university || universityCode
        }&curriculum_version=${identity_version || version.version_number}`
      )
      .then((res) => {
        if (!res.data.competency) {
          return;
        }

        const uniCode = identity_university || universityCode;
        const fetched = {
          ...res.data.competency,
          university_code: uniCode,
        };

        const foundDuplicate = navigatedCompetencies.findIndex(
          (el: CompetencyType) =>
            el.competency_code === competencyCode &&
            el.university_code === uniCode
        );

        if (foundDuplicate !== -1) {
          // let newArray = [
          //   ...navigatedCompetencies.slice(0, foundDuplicate + 1),
          // ];
          // newArray = newArray.map((item) => ({
          //   ...item,
          //   university_code: item.university_code ?? uniCode,
          // }));
          // setNavigatedCompetencies(newArray);
        } else {
          setNavigatedCompetencies([
            ...navigatedCompetencies.map((item: any) => ({
              ...item,
              university_code: item.university_code ?? uniCode,
            })),
            fetched,
          ]);
        }

        setCompetency(res.data.competency);
      })
      .catch(() => {
        setCompetencies([]);
      })
      .finally(() => setLoading(false));
  };

  const fetchCompetencies = () => {
    axios
      .get(
        `/competency/summary?university_code=${universityCode}&curriculum_version=${version.version_number}`
      )
      .then((res) => {
        if (res.data.competencies) {
          setCompetencies(res.data.competencies);
        }
      })
      .catch(() => {
        setCompetencies([]);
      });
  };
  function filterArrayElementByCode(code: string) {
    return competencies.filter((element) => {
      return element.competency_code === code;
    })[0];
  }
  const redirectCompetency = (e: any, id: string) => {
    e.preventDefault();
    navigate(`/view/competency/detail/${id}`);
  };
  if (loading) {
    return <LoadingSpinner />;
  }
  return (
    <>
      <SearchCompetencies
        totalRequiredCredits={null}
        mode="view"
        navigationData={navigatedCompetencies}
        defaultSearchText={competency?.competency_code || ""}
        onSearch={(keyword) => searchCompetency(keyword)}
        snackbarOpen={snackbarOpen}
        setSnackbarOpen={setSnackbarOpen}
      >
        {competency ? (
          <CustomFlex
            style={{
              minHeight: "inherit",
              height: "100%",
              borderBottom: "none",
              alignItems: "flex-start",
              overflowY: "scroll",
              padding: 0,
            }}
          >
            {!isMobile && (
              <CustomGrow>
                <CustomBlock
                  style={{
                    marginRight: "20px",
                    marginLeft: "20px",
                    marginTop: "60px",
                  }}
                  backgroundColor={competency.graphics.iconbg}
                >
                  <StyledImg
                    src={
                      process.env.REACT_APP_IMG_URL + competency.graphics.imgurl
                    }
                    alt=""
                  />
                  <MuiIcon
                    sx={{
                      color: "white",
                      padding: "6px",
                      background: competency.graphics.iconbg,
                      borderRadius: "100px",
                      fontSize: "27px",
                      position: "absolute",
                      bottom: "90px",
                      right: "80px",
                      boxShadow: competency.graphics.iconshadow,
                    }}
                  >
                    {competency.graphics.icon}
                  </MuiIcon>
                  <StyledText fontWeight="700">{competency.title}</StyledText>
                  <div>
                    <StyledText
                      fontWeight="300"
                      color={theme.color.white}
                      textSize={TextSize.small}
                    >
                      {competency.description}
                    </StyledText>
                  </div>
                </CustomBlock>
              </CustomGrow>
            )}
            <FlexGrow style={{ overflowX: "scroll" }}>
              <CustomFlex>
                <FlexGrow>
                  <Header>
                    [{competency.competency_code}] {competency.title}
                  </Header>
                  <span style={{ color: "#0300c4ff", fontWeight: "bold" }}>
                    {competency.program_name} - {competency.display_version}
                  </span>
                </FlexGrow>
                <TabGroup
                  style={{ borderBottom: "none", padding: "0", margin: "0" }}
                >
                  <TabItem active={tab === 0} onClick={() => setTab(0)}>
                    <Icon
                      name="home"
                      style={{ verticalAlign: "text-bottom" }}
                      size={2.5}
                      fixedWidth={false}
                    />{" "}
                    Overview
                  </TabItem>
                  <TabItem active={tab === 1} onClick={() => setTab(1)}>
                    <Icon
                      name="keyboard_double_arrow_up"
                      style={{ verticalAlign: "text-bottom" }}
                      size={2.5}
                      fixedWidth={false}
                    />{" "}
                    Skills
                  </TabItem>
                  {/* <TabItem active={tab === 2} onClick={() => setTab(2)}>
                    <Icon
                      name="grid_view"
                      style={{ verticalAlign: 'text-bottom' }}
                      size={2.5}
                      fixedWidth={false}
                    />{' '}
                    Courses
                  </TabItem> */}
                </TabGroup>
              </CustomFlex>
              {tab === 0 && (
                <>
                  <CustomFlexPlain>
                    <CustomGrowPlain>
                      <Label>Pillars</Label>
                    </CustomGrowPlain>
                    <FlexGrow>
                      <MuiIcon
                        sx={{
                          mr: 1,
                          padding: "4px",
                          background: competency.graphics.iconbg,
                          boxShadow: competency.graphics.iconshadow,
                          borderRadius: "100px",
                          fontSize: "16px",
                          verticalAlign: "sub",
                        }}
                      >
                        {competency.graphics.icon}
                      </MuiIcon>
                      <LabelData>{competency.pillar_title}</LabelData>
                    </FlexGrow>
                  </CustomFlexPlain>
                  <CustomFlexPlain>
                    <CustomGrowPlain>
                      <Label>Subdomain</Label>
                    </CustomGrowPlain>
                    <FlexGrow>
                      <LabelData color={theme.color.lightBlueGray500}>
                        {competency.subdomain_title}
                      </LabelData>
                    </FlexGrow>
                  </CustomFlexPlain>
                  <CustomFlexPlain>
                    <CustomGrowPlain>
                      <Label>Knowledge Area</Label>
                    </CustomGrowPlain>
                    <FlexGrow>
                      <LabelData color={theme.color.lightBlueGray500}>
                        {competency.knowledge_area_title}
                      </LabelData>
                    </FlexGrow>
                  </CustomFlexPlain>

                  {competency.description && (
                    <CustomFlexPlain>
                      <CustomGrowPlain>
                        <Label>Description</Label>
                      </CustomGrowPlain>
                      <FlexGrow>
                        <LabelData
                          textSize={TextSize.sidebar}
                          status={TextStatus.muted}
                        >
                          {competency.description}
                        </LabelData>
                      </FlexGrow>
                    </CustomFlexPlain>
                  )}
                  <CustomFlexPlain>
                    <CustomGrowPlain>
                      <Label>Credits</Label>
                    </CustomGrowPlain>
                    <FlexGrow>
                      <LabelData style={{ paddingRight: "5px" }}>
                        {competency.credits}
                      </LabelData>
                      {competency.required && (
                        <LabelData>-- REQUIRED</LabelData>
                      )}
                    </FlexGrow>
                  </CustomFlexPlain>
                  <CustomFlexPlain>
                    <CustomGrowPlain>
                      <Label>Required</Label>
                    </CustomGrowPlain>
                    <FlexGrow>
                      <LabelData style={{ paddingRight: "5px" }}>
                        {competency.required ? "Yes" : "No"}
                      </LabelData>
                    </FlexGrow>
                  </CustomFlexPlain>
                  <CustomFlexPlain>
                    <CustomGrowPlain>
                      <Label>Prerequisites</Label>
                    </CustomGrowPlain>
                    <FlexGrow>
                      <Ul>
                        {competency.prerequisites ? (
                          competency.prerequisites.map((prerequisite: any) => (
                            <LI>
                              <div>
                                {/* <Link
                                  style={{ textDecoration: "underline" }}
                                  to={`/view/competency/detail/${prerequisite.competency_code}`}
                                  relative="path"
                                > */}
                                <LabelData
                                  style={{
                                    fontWeight: "bold",
                                    verticalAlign: "baseline",
                                  }}
                                >
                                  {prerequisite.prerequisite_competency_code}
                                </LabelData>
                                {/* </Link> */}
                              </div>
                            </LI>
                          ))
                        ) : (
                          <LabelData>--None--</LabelData>
                        )}
                      </Ul>
                    </FlexGrow>
                  </CustomFlexPlain>
                  <CustomFlexPlain>
                    <CustomGrowPlain>
                      <Label>Responsible instructor</Label>
                    </CustomGrowPlain>
                    <FlexGrow>
                      <LabelData color={theme.color.lightBlueGray500}>
                        {competency.instructors}
                      </LabelData>
                    </FlexGrow>
                  </CustomFlexPlain>
                  {/* <CustomFlexPlain>
                    <CustomGrowPlain>
                      <Label>Last modified</Label>
                    </CustomGrowPlain>
                    <FlexGrow>
                      <LabelData color={theme.color.lightBlueGray500}>
                        {competency.instructors}
                      </LabelData>
                    </FlexGrow>
                  </CustomFlexPlain> */}
                </>
              )}
              {tab === 1 && (
                <>
                  <TableComponent navHeight="265px" aria-label="sticky table">
                    <TableHead>
                      <TableRow>
                        {skillColumns.map((column) => (
                          <StyledHeaderCell
                            key={column.id}
                            align={column.align}
                            backgroundColor={theme.color.lightBlueGray50}
                            color={theme.color.lightBlueGray800}
                            style={{ minWidth: column.minWidth }}
                          >
                            {column.label}
                          </StyledHeaderCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {competency.skills.map((row: any, index) => {
                        return (
                          <StyledTableRow
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            key={index}
                          >
                            {skillColumns.map((column) => {
                              if (column.id === "ordinal") {
                                return (
                                  <StyledBodyCell
                                    key={column.id}
                                    align={column.align}
                                  >
                                    {index + 1}
                                  </StyledBodyCell>
                                );
                              }
                              if (column.id === "assessment_description") {
                                return (
                                  <StyledBodyCell
                                    key={column.id}
                                    align={column.align}
                                  >
                                    {row.assessment.description}
                                  </StyledBodyCell>
                                );
                              }
                              const value = row[column.id];
                              return (
                                <StyledBodyCell
                                  key={column.id}
                                  align={column.align}
                                >
                                  {column.format && typeof value === "number"
                                    ? column.format(value)
                                    : value}
                                </StyledBodyCell>
                              );
                            })}
                          </StyledTableRow>
                        );
                      })}
                    </TableBody>
                  </TableComponent>
                </>
              )}
              {tab === 2 && (
                <>
                  <TableComponent navHeight="265px" aria-label="sticky table">
                    <TableHead>
                      <TableRow>
                        {courseColumns.map((column) => (
                          <StyledHeaderCell
                            key={column.id}
                            align={column.align}
                            backgroundColor={theme.color.lightBlueGray50}
                            color={theme.color.lightBlueGray800}
                            style={{ minWidth: column.minWidth }}
                          >
                            {column.label}
                          </StyledHeaderCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {competency.skills.map((row: any, index) => {
                        return (
                          <StyledTableRowNoHover
                            hover={false}
                            role="checkbox"
                            tabIndex={-1}
                            key={index}
                          >
                            {courseColumns.map((column) => {
                              const value = row[column.id];
                              if (column.id === "competencies") {
                                return (
                                  <StyledBodyCell
                                    key={column.id}
                                    align={column.align}
                                  >
                                    {customComps.map((elem) => (
                                      <FlexBox>
                                        <FlexGrow>
                                          <ALink
                                            href="#"
                                            onClick={(e) =>
                                              redirectCompetency(
                                                e,
                                                elem.competency_code
                                              )
                                            }
                                          >
                                            <Ul>
                                              <LiGradient
                                                style={{
                                                  background:
                                                    elem.graphics.iconbg,
                                                }}
                                              >
                                                [{elem.competency_code}]{" "}
                                                {elem.title}
                                              </LiGradient>
                                            </Ul>
                                          </ALink>
                                        </FlexGrow>
                                      </FlexBox>
                                    ))}
                                  </StyledBodyCell>
                                );
                              }
                              return (
                                <StyledBodyCell
                                  key={column.id}
                                  align={column.align}
                                >
                                  {column.format && typeof value === "number"
                                    ? column.format(value)
                                    : value}
                                </StyledBodyCell>
                              );
                            })}
                          </StyledTableRowNoHover>
                        );
                      })}
                    </TableBody>
                  </TableComponent>
                </>
              )}
            </FlexGrow>
          </CustomFlex>
        ) : (
          <LoadingSpinner />
        )}
      </SearchCompetencies>
    </>
  );
}
export default ViewCompetencyDetail;
